// extracted by mini-css-extract-plugin
module.exports = {"normalMax":"Index_normalMax__2M8HC","normal":"Index_normal__3rYxm","normalH5":"Index_normalH5__3kn1L","animationFade":"Index_animationFade__1sYW3"};